'use strict';

import React, {Component} from 'react';
import PropTypes from "prop-types";

import Modal from "react-bootstrap/Modal"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {MetricKeys, MetricLabels} from './Constants';
import MockTermConstants from "@uw-it-sis/lib-react/lib/MockTermConstants";
import Backdoor from "@uw-it-sis/lib-react/lib/Backdoor";
import AppInfo from "@uw-it-sis/lib-react/lib/AppInfo";

const analyticsStore = appStore.getAnalyticsStore();

/**
 * The form to set "now" when testing calendar related features.
 */
class NowTime extends Component {

    constructor(props) {
        super(props);
        // Don't initialize state based on props.
        this.state = {
            showModal: false,
            selectedNow: appStore.getPrettyPrintedNow(),
            selectedMockDate: null
        };

        this.submit = this.submit.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleMockDateSelect = this.handleMockDateSelect.bind(this);
    }

    submit() {
        let newNow = this.state.selectedNow;

        if (this.state.selectedMockDate) {
            newNow = this.state.selectedMockDate;
        }

        if (newNow) {
            appStore.carefullySetNow(newNow);
        } else {
            appStore.clearSetNow();
        }

        this.close();
    }

    handleKeyUp(event) {
        if (event.key === 'Enter') {
            this.submit();
        } else {
            this.setState({ selectedNow: event.target.value });
        }
    }

    handleMockDateSelect = (event) => this.setState({ selectedMockDate: event.target.value });
    close = () => this.setState({ showModal: false });
    open = () => this.setState({ showModal: true });

    render() {
        let mockDateOptions = MockTermConstants.MOCK_TERM_SET.map(function (term, index) {
            return (
                <option key={index} value={term.date}>{term.label + " (" + term.date + ")"}</option>
            );
        });

        return (
            <>
                <Button variant="inline-link" className="fs-7" onClick={this.open}>Now Time: {appStore.getPrettyPrintedNow()}</Button>
                <Modal id="modal-now-time"
                       show={this.state.showModal}
                       onHide={this.close}
                       size="sm"
                       aria-labelledby="modal-now-time-title"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title id="modal-now-time-title">Change Date &amp; Time</Modal.Title>
                    </Modal.Header>
                    <Modal.Body ref="modalBody">
                        <Form.Group id="setMockDate">
                            <Form.Label>Pick Mock Date</Form.Label>
                            <Form.Control as="select"
                                          className="form-control"
                                          name="mockDateSelector"
                                          ref="mockDateSelector"
                                          onChange={this.handleMockDateSelect}
                                          defaultValue="">
                                <option value="">Select a date</option>
                                {mockDateOptions}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group id="setNow">
                            <Form.Label>Set 'Now'</Form.Label>
                            <Form.Control
                                type="text"
                                defaultValue={this.state.selectedNow}
                                placeholder="Enter text"
                                onKeyUp={this.handleKeyUp}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.submit} variant="primary">Submit</Button>
                        <Button onClick={this.close} variant="link">Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

/**
 * The footer component.
 */
const Footer = (props) => {

    const logEvent = (context) => {
        // For nav events, dest is usually created by OrgUtils.getPageFromUrl(href), but since
        // footer links are to outside of myplan, we'll just log the context.
        // FIXME: See what the actual value of this one is
        const labels = analyticsStore.label(MetricLabels.navLinkDestName, context).add(MetricLabels.navType, "footer").get();
        analyticsStore.addEvent(MetricKeys.navigation, labels, {context: context});
    };

    let devTools = [];

    if ( appStore.isAuthenticated() && appStore.isBackdoorAllowed() ) {
        devTools.push({ key: "backdoor", component: <Backdoor/> });
    }

    if ( appStore.isDevMode() || appStore.isBackdoorAllowed() ) {
        devTools.push({ key: "nowtime", component: <NowTime/> });
    }

    devTools = devTools.concat(props.devTools ?? []);

    return (
        <footer className="d-print-none d-grid gap-3 p-3 text-center fs-7 bg-navigate border border-3 border-start-0 border-end-0 border-bottom-0" role="contentinfo">
            <ul className="list-inline list-inline-pipe-separated m-0">
                <li className="list-inline-item"><a href="https://itconnect.uw.edu/learn/tools/myplan-academic-planner/" onClick={() => logEvent("itconnect-myplan-help")} target="_blank">MyPlan Help</a></li>
                <li className="list-inline-item"><a href="https://itconnect.uw.edu/help/" onClick={() => logEvent("itconnect-contact")} target="_blank">Contact</a></li>
                <li className="list-inline-item"><a href="http://www.washington.edu/online/terms" target="_blank">Terms</a></li>
                <li className="list-inline-item"><a href="http://www.washington.edu/online/privacy" target="_blank">Privacy</a></li>
            </ul>
            <div>&copy; {new Date().getFullYear()} University of Washington</div>
            <ul className="list-inline list-inline-pipe-separated m-0">
                <li className="list-inline-item" key="info"><AppInfo /></li>
                {devTools.map(tool => (
                    <li className="list-inline-item" key={tool.key}>
                        {tool.component}
                    </li>
                ))}
            </ul>
        </footer>
    );
};

Footer.propTypes = {
    devTools: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        component: PropTypes.element.isRequired
    })),
}

export default Footer;